<div class="col-lg-12 nopadding">
  <br />
  @if(isLoadingResults){
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>}
  <p-table [columns]="cols" [value]="userListDataset" [paginator]="true" [resizableColumns]="true"
    alwaysShowPaginator="true" columnResizeMode="expand" appendTo="body" [totalRecords]="userListDataset.length"
    paginatorPosition="both" sortMode="multiple" [rows]="15" [lazy]="false" 
    [pageLinks]="constantService.GRID_DEFAULT_PAGELINKS" [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION"
    selectionMode="single" [scrollable]="true" scrollHeight="80vh" styleClass="userListTable"
    #dt>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          {{constantService.NO_RECORDFOUND_MSG}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <!-- <th id="tableHeaderCheckbox" style="width: 3em">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th> -->
        @for(col of columns; track col.field + '-'+ $index) {
        <th id="colHeader" pResizableColumn [pSortableColumn]="col.field" [ngClass]="
            (col?.display | lowercase) == 'false' ? 'notdisplay' : ''">
          {{ col.header }}
          @if((col.header | lowercase) !== 'action'){
          <p-sortIcon [field]="col.field"></p-sortIcon>
          }
        </th>
      }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" class="ui-widget-NoUpdated-row">
        <!-- <td style="width: 3em;padding-left: 6px !important;">
          <p-tableCheckbox [id]="'checkbox'+ rowIndex" [value]="row" (click)="$event.stopPropagation()"></p-tableCheckbox>
        </td> -->
        @for(col of columns; track col.field + '-'+ $index) {
        <td class="ui-resizable-column"
          [ngClass]="col.header==='Action' ? 'text-center':''">
          @if(col.header==='Action'){
          <span>
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-xxx fa-eye"
              (click)="onRowSelect('View',rowIndex,row);"></p-button>
            <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Edit" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-edit" 
              (click)="onRowSelect('edit',rowIndex,row);"></p-button>

             <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" [matTooltipShowDelay]="1000"
              matTooltipPosition="above" appendTo="body" icon="fa fa-fw fa-trash" 
              (click)="onDelete(row);"></p-button>

          </span>
        }
          @if(col.header!=='Action'){
          <span>
            {{row[col.field]}}
          </span>
        }
        </td>
      }
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      </ng-template>
      <ng-template pTemplate="paginatorright">
      Total Records: {{ userListDataset.length == 0 ? 0 : userListDataset.length }}
    </ng-template>
  </p-table>
  <br />
</div>

<!-- Quick View Panel Code  -->
 @if(View){
<p-drawer styleClass="u ui-sidebar-lg" 
  [style]="{'width':'auto','max-width': '920px','height':'auto','overflow-y': 'auto','max-height':'100%'}"
  [(visible)]="View" position="right" [baseZIndex]="10000">
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-col-12">
      @for(col of cols; track col; let i = $index){
      <div class="ui-grid-col-6"> <span>
        @if(col.header!='Action'){
          <div class="ui-grid-col-4 quick-view-grid-row-hg">
            <label for="columnHeader">{{col.header}}</label>
          </div>
        }
        @if(col.header!='Action'){
          <div class="ui-grid-col-6 quick-view-grid-row-hg">
            @if((col?.datatype | lowercase)!=='boolean'){
            <input [disabled]="true" pInputText
              [(ngModel)]="selectedUser[col.field]" />
          }
          @if((col?.datatype | lowercase)=='boolean'){
            <input [disabled]="true" pInputText
              [value]="getBooleanValue(selectedUser[col.field])">
          }
          </div>
        }
        </span>
      </div>
    }
    </div>
  </div>
</p-drawer>
 }

 @if(edit){
<p-dialog id="viewUserDetails" [(visible)]="edit" header="" appendTo="body" height="auto"
  width="auto" [style]="{width: '90%', minWidth: '500px'}" [minY]="100" [maximizable]="true"
  minimizeIcon="pi pi-window-minimize" maximizeIcon="pi pi-window-maximize" closeIcon="pi pi-times" [modal]="false"
  (onHide)="closeEditDialog()"
  draggable="true" styleClass="userlist">
  <app-add-user [rowData]="selectedUser" (closeDialog)="closeDialog($event)" >

  </app-add-user>
  <ng-template #footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <p-button id="btn_cognito_close" type="button" icon="fa fa-close"
        (click)="closeEditDialog()" label="Close"></p-button>
    </div>
  </ng-template>
</p-dialog>
 }

<p-confirmDialog id="userEditConfirmationDialog" header="Confirmation" key="userEditConfirmationDialog" icon="pi pi-exclamation-triangle" appendTo="body"></p-confirmDialog>
